import React from 'react';

export const CloseSideBarSVG = ({ className }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.125 0.875L0.875 17.125M0.875 0.875L17.125 17.125"
      stroke="#999999"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    />
  </svg>
);

export const ExpandSideBarSVG = ({ className }) => (
  <svg
    width="13"
    height="8"
    viewBox="0 0 13 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.206 7.20526C11.816 7.59875 11.183 7.59674 10.792 7.20726L6.499 2.91598L2.206 7.20726C1.815 7.59775 1.183 7.59775 0.792 7.20626C0.402 6.81378 0.403001 6.181 0.793 5.78952L5.792 0.79236C5.988 0.59712 6.243 0.5 6.499 0.5C6.755 0.5 7.01 0.59712 7.206 0.79236L12.205 5.78952C12.596 6.181 12.596 6.81378 12.206 7.20526Z"
      fill="#3E4968"
      className={className}
    />
  </svg>
);
